// extracted by mini-css-extract-plugin
module.exports = {"ModalHeader":"ModalEditPolicySmoke_ModalHeader__RZQTS","ModalBody":"ModalEditPolicySmoke_ModalBody__3o4Df","ButtonClose":"ModalEditPolicySmoke_ButtonClose__2do_q"};